export enum CheckoutSteps {
  Start = 0,
  Account = 1,
  Shipping = 2,
  Billing = 3,
  Contract = 4,
  Payment = 5,
  Complete = 6,
}
